export const PLACES_FETCHED = 'PLACES_FETCHED';
export const PLACES_ADD = 'PLACES_ADD';
export const PLACES_CLEAR = 'PLACES_CLEAR';
